import { StandardAsset } from '$components/Asset';
import cn from 'classnames';
import { HTMLAttributes, useEffect, useState } from 'react';

import { IGalleryAsset } from './';

export function GalleryImage(
  props: IGalleryAsset & HTMLAttributes<HTMLElement>,
) {
  const {
    className,
    activeSlideIndex,
    direction,
    assets,
    active,
    index,
    count,
  } = props;

  const [zValue, setZValue] = useState(0);

  useEffect(() => {
    if (direction === 'right') {
      setZValue(
        index < activeSlideIndex
          ? index
          : activeSlideIndex === index
          ? 100
          : count - index,
      );
    } else if (direction === 'left') {
      setZValue(
        index <= activeSlideIndex
          ? index
          : activeSlideIndex + 1 === index
          ? 100
          : count - index,
      );
    }
  }, [activeSlideIndex, count, index, direction]);

  const [devicePixelRatio, setDevicePixelRatio] = useState(1);
  useEffect(() => {
    setDevicePixelRatio(Math.min(2, window.devicePixelRatio));
  }, []);

  return (
    <div
      className={cn(
        className,
        'absolute top-0 overflow-hidden rounded-[2.5rem]',
        active && direction === 'right'
          ? 'duration-[600ms] gallery-item left-0'
          : index > activeSlideIndex
          ? 'gallery-item-inactive duration-[600ms]'
          : '',

        index < activeSlideIndex ? 'keep-left left-0' : '',
        index > activeSlideIndex ? 'left-[133.33%]' : '',
      )}
      style={{ zIndex: zValue }}
    >
      <StandardAsset
        sizes={
          '(max-width: ' +
          Math.floor(500 * devicePixelRatio) +
          'px) ' +
          Math.floor(500 / devicePixelRatio) +
          'px, ' +
          Math.floor(1024 / devicePixelRatio) +
          'px'
        }
        assets={assets}
      />
    </div>
  );
}
